// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__PL29j","modalFooterButton":"ModalNotes_modalFooterButton__sKC6y"};